import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import React, { useState, useEffect } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import CustomCheckbox from "../Inputs/CustomCheckbox";
import Label from "../Misc/Label";
import { useDispatch, useSelector } from "react-redux";
import { addCampaignDetails } from "../../redux/actions/uiActions";
import { addCampaign, updateProject } from "../../redux/actions/web3Actions";
import { useHistory } from "react-router-dom";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import moment from "moment";

import InputWithHorizontalLabel from "../Inputs/InputWithHorizontalLabel";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
}));

const TokenPoolReqStepTwo = ({ changeFlag, onNextClick, setDisableButton }) => {
  const classes = useStyles();
  // const projectData = useSelector((state) => state.ui.projectData);
  // console.log("projectData(addProject) response => ", projectData);
  const history = useHistory();
  const web3context = useWeb3React();

  const [contactName, setContactName] = useState("");
  const [minimumKOLRanking, setMinimumKOLRanking] = useState("");
  const [maxAlloPerKOL, setMaxAlloPerKOL] = useState("");

  const [minAlloPerKOL, setMinAlloPerKOL] = useState("");
  const [preSaleTokenPrice, setPreSaleTokenPrice] = useState("");
  const dispatch = useDispatch();

  const [marketingStartDate, setmarketingStartDate] = React.useState(
    new Date()
  );
  const [marketingEndDate, setmarketingEndDate] = React.useState(new Date());
  const campaignData = useSelector((state) => state.ui.campaignData);
  const projectData = useSelector((state) => state.ui.projectData);
  const isUser = useSelector((state) => state.ui.isUser);

  console.log("campaignData from redux=> ", campaignData);
  // console.log("projectData from redux", projectData);
  let project = isUser.project;
  console.log("isUser from redux", project?.projectName);

  const handleStartDateChange = (date) => {
    setmarketingStartDate(date);
  };
  const handleEndDateChange = (date) => {
    setmarketingEndDate(date);
  };

  // const [isTwitter, setIsTwitter] = useState("");

  // const [isYoutube, setIsYoutube] = useState("");
  // const [isTiktok, setIsTiktok] = useState("");

  var formattedStartDate = marketingStartDate.toISOString().slice(0, 10);
  var formattedEndDate = marketingEndDate.toISOString().slice(0, 10);

  let updatedCategory = [];
  let postDescArr = campaignData.postDescription.split(" ");

  const callbackFunction = () => {
    history.push("/progresshub");

    // console.log("HASAN CHALA");
  };

  const search = {
    name: campaignData.campaignName,
    search_type_cd: 0,
    input_format: 1,
    start_date: formattedStartDate,
    end_date: formattedEndDate,
    category_ids: updatedCategory,
    // keywords: [[campaignData.postDescription]],
  };

  useEffect(() => {
    if (
      minimumKOLRanking &&
      maxAlloPerKOL &&
      minAlloPerKOL &&
      preSaleTokenPrice &&
      marketingStartDate &&
      marketingEndDate
    )
      setDisableButton(false);
  }, [
    minimumKOLRanking,
    maxAlloPerKOL,
    minAlloPerKOL,
    preSaleTokenPrice,
    marketingStartDate,
    marketingEndDate,
  ]);

  useEffect(() => {
    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), {});

    var filtered = Object.filter(
      campaignData.platforms,
      (plat) => plat.posts !== "" || plat.followers !== ""
    );

    Object.keys(filtered).map((f, i) => updatedCategory.push(filtered[f].key));
    console.log(updatedCategory);
    console.log("PLATFORM MODIFIED", filtered);

    if (changeFlag === 2) {
      console.log("flag clicked cam 2");
      const formattedStart = moment(marketingStartDate).format(
        "yyyy-MM-DDTHH:mm:ss[Z]"
      );
      const formattedEnd = moment(marketingEndDate).format(
        "yyyy-MM-DDTHH:mm:ss[Z]"
      );
      dispatch(
        addCampaignDetails({
          minimumKOLRanking,
          maxAlloPerKOL,
          minAlloPerKOL,
          preSaleTokenPrice,
          marketingStartDate: formattedStart,
          marketingEndDate: formattedEnd,
        })
      );
      onNextClick();
      dispatch(
        addCampaign(
          web3context?.account,
          isUser?.project,
          {
            ...campaignData,
            timestamp: Date.now(),
            minimumKOLRanking,
            maxAlloPerKOL,
            minAlloPerKOL,
            preSaleTokenPrice,
            marketingStartDate: formattedStart,
            marketingEndDate: formattedEnd,
            search,
          },
          callbackFunction
        )
      );

      // const mbl = isUser?.project?.marketingBudgetLeft - campaignData?.budget;
      // console.log("add mbl========", mbl);

      // dispatch(updateProject(isUser?.project?._id, mbl));
    }
  }, [changeFlag]);
  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 2</Typography>

        <Typography className={classes.headingDesc}>
          Manage your campaign funds
        </Typography>
      </Box>

      <Box>
        <InputWithLabel
          label="Minimum KOL Ranking"
          value={minimumKOLRanking}
          setValue={setMinimumKOLRanking}
          placeholder="3"
          type="number"
          rightText="/ 5"
          width={80}
          maxValue1={5}
        />
      </Box>

      <Box marginBottom="2.6rem">
        <Label label="Marketing Date Range" />
        <Box display="flex" alignItems="center">
          <Box marginRight="4rem">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToobar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="From"
                value={marketingStartDate}
                onChange={handleStartDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                inputVariant="outlined"
              />
            </MuiPickersUtilsProvider>
          </Box>
          <Box>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToobar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="To"
                value={marketingEndDate}
                onChange={handleEndDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                inputVariant="outlined"
              />
            </MuiPickersUtilsProvider>
          </Box>
        </Box>
      </Box>
      <InputWithLabel
        label="Max Allo Per KOL (USDT)"
        value={maxAlloPerKOL}
        setValue={setMaxAlloPerKOL}
        placeholder="5000"
        type="number"
      />
      <InputWithLabel
        label="Min Allo Per KOL (USDT)"
        value={minAlloPerKOL}
        setValue={setMinAlloPerKOL}
        placeholder="1000"
        type="number"
      />
      {/* <InputWithLabel
        label="Min Allo Per KOL (USDT)"
        value={contactName}
        setValue={setContactName}
        placeholder="1000"
        type="number"
      /> */}
      <InputWithLabel
        label="Pre-Sale Token Price (USDT)"
        value={preSaleTokenPrice}
        setValue={setPreSaleTokenPrice}
        placeholder="0.05"
        type="number"
      />
    </Box>
  );
};

export default TokenPoolReqStepTwo;
